import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postCreaditCardRequest = async ({ customerId, emailNotification, smsNotification }: JsonDataItem) => {
  const { data } = await baseQuery('credit-card-request', {
    type: 'POST',
    body: {
      customer_id: customerId,
      email: emailNotification,
      sms_contacts: smsNotification,
    },
  });

  return data;
};
